import { GridColDef } from '@mui/x-data-grid';
import { TableTooltip } from '../../../../components/general/table';
import { DateTooltip } from '../../../../components/general/dateTooltip';
import {
    FunctionariesSwitchHistoricalProps,
    functionariesFieldEquivalences,
} from './props';
import { FunctionariesSwitchHistorical } from '../../../../../shared/types/systemConfiguration/functionariesSwitch';

export const useFunctionariesSwitchHistorical = ({
    historical,
}: FunctionariesSwitchHistoricalProps) => {
    const columns: GridColDef<FunctionariesSwitchHistorical>[] = [
        {
            field: 'fieldChange',
            headerName: 'Campo Modificado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.elementos?.field
                            ? functionariesFieldEquivalences[
                                params.row.elementos.field
                            ] || params.row.elementos.field
                            : ''
                    }
                />
            ),
        },
        {
            field: 'oldValue',
            headerName: 'Valor Anterior',
            minWidth: 120,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.elementos?.oldValue !== undefined &&
                        params.row.elementos?.oldValue !== null
                            ? String(params.row.elementos.oldValue)
                            : ''
                    }
                />
            ),
        },
        {
            field: 'newValue',
            headerName: 'Valor Nuevo',
            minWidth: 120,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.elementos?.newValue !== undefined &&
                        params.row.elementos?.newValue !== null
                            ? String(params.row.elementos.newValue)
                            : ''
                    }
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de modificación',
            minWidth: 100,
            flex: 0.3,
            renderCell: (params) => (
                <DateTooltip date={params.row.created_at} showFornow />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.createdBy
                            ? `(${params.row.createdBy.username}) ${params.row.createdBy.name} ${params.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
    ];

    const toDisplay = (val: any, field?: string): string => {
        if (val === null || val === undefined) return '';
        if (typeof val === 'boolean') return val ? 'Sí' : 'No';

        const isParamField = field === 'area' || field === 'position';

        if (isParamField) {
            if (typeof val === 'object' && val !== null) {
                return val.name ?? val.code ?? val.id ?? '';
            }
            return String(val);
        }

        if (typeof val === 'object') {
            return val.name ?? JSON.stringify(val);
        }

        return String(val);
    };

    const rows =
        historical?.flatMap((row) => {
            if (!row.changes) return [];

            const { changes, created_at, createdBy } = row;

            return changes.map((elemento, index) => {
                const field = elemento.field ?? '';

                const newValueDisplay = toDisplay(elemento.newValue, field);
                const oldValueDisplay = toDisplay(elemento.oldValue, field);

                return {
                    ...row,
                    elementos: {
                        ...elemento,
                        newValue: newValueDisplay,
                        oldValue: oldValueDisplay,
                    },
                    id: row.id + String(index),
                    created_at,
                    createdBy,
                } as FunctionariesSwitchHistorical & {
                    elementos: {
                        field?: string;
                        newValue?: any;
                        oldValue?: any;
                    };
                };
            });
        }) || [];

    return {
        columns,
        rows,
    };
};
